import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  user: UserModel | null;
  tokenObj: TokenModel | null;
}

const initialState: AuthState = {
  user: null,
  tokenObj: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    refreshToken: (state, action: PayloadAction<TokenModel>) => {
      state.tokenObj = action.payload;
    },
    authenticate: (state, action: PayloadAction<UserModel>) => {
      state.user = action.payload;
    },
    setProfile: (state, action: PayloadAction<Partial<UserModel>>) => {
      state.user = state.user ? { ...state.user, ...action.payload } : state.user;
    },
    logout: () => initialState,
  },
});

export const { refreshToken, authenticate, setProfile, logout } = authSlice.actions;

export default authSlice;
